import { reactive, computed } from 'vue'

export type AutoRtInfo = Record<string, any>

export function createEmptyAutoRTInfo (): AutoRtInfo {
  return {
    logoImage: '',
    clientId: '',
    dialogName: '',
    clientName: '',
    termurl: '',
    privacyurl: '',
    occupationurl: '',
    handlingurl: '',
    clientServiceName: '',
    privacyLabel: '',
    showTrailingBr: false,
    permissionType: 0,
    oldPermissionType: 0,
    googleConversationId: null,
    googleConversationLabel: null,
    agreed: false
  }
}

/** Vue 2.7 / 3 共通のモジュール級 reactive（Vue.prototype は使わない） */
export const autoRtState = reactive({
  info: createEmptyAutoRTInfo()
})

export function useAutoRtSession () {
  const info = computed(() => autoRtState.info)
  const isActive = computed(() => !!autoRtState.info.clientId)
  const isAgreedForSend = computed(
    () => !!autoRtState.info.clientId && autoRtState.info.agreed === true
  )

  function getAutoRtInfo (): AutoRtInfo {
    return autoRtState.info
  }

  function setAutoRtInfo (next: AutoRtInfo) {
    autoRtState.info = { ...createEmptyAutoRTInfo(), ...next }
  }

  function clearAutoRtInfo () {
    autoRtState.info = createEmptyAutoRTInfo()
  }

  function setAgreed (agreed: boolean) {
    autoRtState.info = { ...autoRtState.info, agreed: !!agreed }
  }

  return {
    state: autoRtState,
    info,
    isActive,
    isAgreedForSend,
    getAutoRtInfo,
    setAutoRtInfo,
    clearAutoRtInfo,
    setAgreed
  }
}

/** Options API / 非 setup コンテキスト向け */
export function getAutoRtSession () {
  return useAutoRtSession()
}
